import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/staff";

// export const saveOrUpdate = staff => axios.post(API_PATH + "/save", staff);
//100924 - update v4 keycloak
export const saveOrUpdate = staff => axios.post(API_PATH + "/save-and-create-user-v4", staff);

export const saveIsActive = staffIsActive => axios.post(API_PATH + "/update-is-active", staffIsActive);

export const getStaffById = staffId => axios.get(API_PATH + "/getbyid/" + staffId);

export const deleteStaff = staffId => axios.delete(API_PATH + "/mark-delete/" + staffId);

export const pagingStaff = searchStaff => axios.post(API_PATH + "/search-by-page", searchStaff);

export const getAllStaff = () => axios.post(API_PATH + "/search-by-page", { pageIndex: 1, pageSize: 100000 });

export const getAppointmentByCurrentUser = () => axios.get(API_PATH + "/get-appointment-by-currentUser");

export const getStaffByRoom = (roomId) => axios.get(API_PATH + "/get-staff-by-room/" + roomId);

export const getStaffByListRoom = (roomType) => axios.get(API_PATH + "/get-staffs-by-list-room/" + roomType);

export const saveStaff = (staff) => axios.post(API_PATH + "/save", staff)

export const getStaffByDepartment = (departmentId) => axios.get(API_PATH + "/get-staff-by-department/" + departmentId);

export const getByDepOrListDepId = (staff) => axios.post(API_PATH + "/get-staffs-by-department-or-list-id", staff)
export const updateInsInfo = (staff) => axios.post(API_PATH + "/update-ins-info", staff)

export const getStaffByRoomOrDepartment = (obj) => axios.post(API_PATH + "/get-staff-department-room", obj);

export const saveOrUpdateUserStaff = (obj) => axios.post(API_PATH + "/save-or-update-user-staff", obj);

export const syncStaffFromHRM = (obj) => axios.post(API_PATH + "/sync-staff-from-HRM", obj);